module.exports = __webpack_public_path__ + "img/oryl_autoteile_logo.7132b972.jpg";